module.exports = __webpack_public_path__ + "assets/66e18eeed1e56733fcf0cf2c4d69fe00.jpg";